import React from 'react'
import {
  Flex, Select, Text
} from '@chakra-ui/react'
import {
  FiChevronLeft,
  FiChevronRight,
  FiChevronsLeft,
  FiChevronsRight,
} from 'react-icons/fi'
import { TableIconButton } from './styles'

const Pagination = ({
  canPreviousPage,
  canNextPage,
  pageOptions,
  pageCount,
  gotoPage,
  nextPage,
  previousPage,
  pageSize,
  pageIndex,
  setPageSize,
}) => {
  return (
    <Flex justifyContent="space-between" flexDirection="row" my={3}>
      <Flex flexDirection="row">
        <TableIconButton
          mr={2}
          onClick={() => gotoPage(0)}
          isDisabled={!canPreviousPage}
          icon={<FiChevronsLeft size={20} />}
        />
        <TableIconButton
          mr={2}
          isDisabled={!canPreviousPage}
          onClick={() => previousPage()}
          icon={<FiChevronLeft size={20} />}
        />
      </Flex>
      <Flex justifyContent="center" alignItems="center" justifyContent="center">
        <Text mr={4}>
          Page{' '}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>{' '}
        </Text>

        <Select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value))
          }}
          width="120px"
        >
          {[5, 10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </Select>
      </Flex>
      <Flex flexDirection="row">
        <TableIconButton
          ml={2}
          isDisabled={!canNextPage}
          onClick={() => nextPage()}
          icon={<FiChevronRight size={20} />}
        />
        <TableIconButton
          ml={2}
          onClick={() => gotoPage(pageCount ? pageCount - 1 : 1)}
          isDisabled={!canNextPage}
          icon={<FiChevronsRight size={20} />}
        />
      </Flex>
    </Flex>
  )
}

export default Pagination
